// Filter-Drawer per URL-Hash öffnen
// Link im Theme-Editor: /collections/<handle>#filter-duftnote
const FILTER_HASH_MAP = {
  'filter-duftnote': 'duftnote',
};

function openFilterDrawerFromHash() {
  const hash = window.location.hash.replace('#', '');
  const filterGroupLabel = FILTER_HASH_MAP[hash];
  if (!filterGroupLabel) return;

  customElements.whenDefined('facets-drawer').then(() => {
    const drawer = document.getElementById('facets-drawer');
    if (!drawer) return;

    drawer.show().then(() => {
      setTimeout(() => {
        drawer.querySelectorAll('summary').forEach((summary) => {
          if (summary.textContent.trim().toLowerCase().includes(filterGroupLabel)) {
            const parent = summary.closest('details');
            if (parent && !parent.open) summary.click();
            summary.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
      }, 300);
    });
  });
}

// Beim Seitenload
openFilterDrawerFromHash();

// Bei Hash-Änderung (andere Seite → diese Seite)
window.addEventListener('hashchange', openFilterDrawerFromHash);

// Klick auf Links mit bekanntem Filter-Hash – auch wenn Hash bereits gesetzt ist
document.addEventListener('click', (e) => {
  const link = e.target.closest('a[href]');
  if (!link) return;
  const hash = link.getAttribute('href').split('#')[1];
  if (!hash || !FILTER_HASH_MAP[hash]) return;
  e.preventDefault();
  history.replaceState(null, '', '#' + hash);
  openFilterDrawerFromHash();
});


/* =====================================================
   Akkordeon-Tab per URL-Hash öffnen
   Link im Theme-Editor: #details-material
   → scrollt zum Anker #details und klappt den Tab auf,
     dessen Titel den Suchbegriff enthält
   ===================================================== */

const ACCORDION_HASH_MAP = {
  'details-material': { anchor: 'details', title: 'material' },
};

function openAccordionFromHash() {
  const target = ACCORDION_HASH_MAP[window.location.hash.replace('#', '')];
  if (!target) return;

  customElements.whenDefined('accordion-disclosure').then(() => {
    const anchor = document.getElementById(target.anchor);
    if (!anchor) return;

    // Nur in der Section direkt unter dem Anker suchen
    const scope = anchor.closest('.shopify-section')?.nextElementSibling || document;
    const accordion = [...scope.querySelectorAll('accordion-disclosure')].find((el) =>
      el.querySelector('.accordion__question')?.textContent.trim().toLowerCase().includes(target.title)
    );
    if (accordion && !accordion.classList.contains('is-open')) {
      accordion.querySelector('summary')?.click();
    }

    // Liegt der Tab weit unter dem Anker (mobil, Section-Kopf darüber),
    // direkt zum Tab scrollen – sonst landet er am unteren Bildrand
    let scrollZiel = anchor;
    if (accordion) {
      const abstand = accordion.getBoundingClientRect().top - anchor.getBoundingClientRect().top;
      if (abstand > window.innerHeight * 0.4) scrollZiel = accordion;
    }

    const sanft = window.matchMedia('(prefers-reduced-motion: no-preference)').matches;
    scrollZiel.scrollIntoView({ behavior: sanft ? 'smooth' : 'auto' });

    // Nachladende Bilder/Videos darüber verschieben das Ziel während des Scrollens –
    // danach (und nach dem Seitenload) einmal nachkorrigieren
    // Scrollt die Person selbst, nicht mehr eingreifen
    let selbstGescrollt = false;
    const stopp = () => { selbstGescrollt = true; };
    ['wheel', 'touchstart', 'keydown'].forEach((typ) => window.addEventListener(typ, stopp, { once: true, passive: true }));

    const nachkorrigieren = () => {
      if (selbstGescrollt) return;
      const soll = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
      if (Math.abs(scrollZiel.getBoundingClientRect().top - soll) > 20) {
        scrollZiel.scrollIntoView({ behavior: 'auto' });
      }
    };
    setTimeout(nachkorrigieren, 1000);
    if (document.readyState !== 'complete') {
      window.addEventListener('load', () => setTimeout(nachkorrigieren, 300), { once: true });
    }
  });
}

// Beim Seitenload
openAccordionFromHash();

// Bei Hash-Änderung (andere Seite → diese Seite)
window.addEventListener('hashchange', openAccordionFromHash);

// Klick auf Links mit bekanntem Akkordeon-Hash – auch wenn Hash bereits gesetzt ist
document.addEventListener('click', (e) => {
  const link = e.target.closest('a[href]');
  if (!link) return;
  const hash = link.getAttribute('href').split('#')[1];
  if (!hash || !ACCORDION_HASH_MAP[hash]) return;
  e.preventDefault();
  history.replaceState(null, '', '#' + hash);
  openAccordionFromHash();
});


/* =====================================================
   Mobiles Menü – Abwärts-Navigation (Akkordeon)
   Markup: snippets/main-menu-drawer.liquid
   Styles: assets/custom.css (Abschnitt „Mobiles Menü")
   ===================================================== */

function closeMenuAccordionItem(item) {
  item.setAttribute('data-open', 'false');
  item.querySelector('[data-accordion-toggle]')?.setAttribute('aria-expanded', 'false');
  // Alles, was darunter offen war, mit zurücksetzen
  item.querySelectorAll('[data-accordion-sub][data-open="true"]').forEach(closeMenuAccordionItem);
}

/**
 * Sorgt dafür, dass ein weit unten geöffneter Menüpunkt samt Unterebene
 * im Sichtbereich landet – nie weiter als bis der Punkt selbst oben steht.
 */
function revealMenuAccordionItem(item) {
  const scroller = item.closest('.menu-drawer__panel-body');
  if (!scroller) return;

  const itemBox = item.getBoundingClientRect();
  const scrollerBox = scroller.getBoundingClientRect();
  const ueberstand = itemBox.bottom - scrollerBox.bottom;
  if (ueberstand <= 0) return;

  const maxVerschiebung = itemBox.top - scrollerBox.top;
  const sanft = window.matchMedia('(prefers-reduced-motion: no-preference)').matches;

  scroller.scrollBy({
    top: Math.min(ueberstand + 16, maxVerschiebung),
    behavior: sanft ? 'smooth' : 'auto',
  });
}

function initMenuAccordion() {
  const drawer = document.getElementById('menu-drawer');
  if (!drawer || drawer.dataset.accordionReady === 'true') return;
  drawer.dataset.accordionReady = 'true';

  drawer.addEventListener('click', (event) => {
    const button = event.target.closest('[data-accordion-toggle]');
    if (!button) return;

    const item = button.parentElement;
    const isSub = item.hasAttribute('data-accordion-sub');
    const willOpen = item.getAttribute('data-open') !== 'true';

    if (willOpen) {
      // Immer nur ein Punkt gleichzeitig offen – Unterebenen nur innerhalb ihrer Liste
      const scope = isSub ? item.parentElement : drawer;
      const selector = isSub ? '[data-accordion-sub][data-open="true"]' : '[data-accordion-item][data-open="true"]';
      scope.querySelectorAll(selector).forEach(closeMenuAccordionItem);

      item.setAttribute('data-open', 'true');
      button.setAttribute('aria-expanded', 'true');

      // Erst nach dem Aufklappen scrollen, sonst ist die Höhe noch 0
      const panel = item.querySelector('.menu-accordion__panel');
      const nachAnimation = () => revealMenuAccordionItem(item);
      panel?.addEventListener('transitionend', nachAnimation, { once: true });
      setTimeout(nachAnimation, 400);
    } else {
      closeMenuAccordionItem(item);
    }
  });

  // Menü geschlossen: beim nächsten Öffnen wieder mit der ersten Ebene starten
  drawer.addEventListener('dialog:after-hide', () => {
    drawer.querySelectorAll('[data-accordion-item][data-open="true"]').forEach(closeMenuAccordionItem);
  });
}

initMenuAccordion();
document.addEventListener('shopify:section:load', initMenuAccordion);


/* =====================================================
   Custom Quicklink Bar – aktives Verzeichnis in den Blick rücken
   Markup: sections/custom-quicklinks.liquid

   Die Leiste scrollt horizontal. Auf Mobile liegt das aktive
   Verzeichnis sonst leicht außerhalb des sichtbaren Bereichs.
   ===================================================== */

function revealActiveQuicklink(list) {
  const active = list.querySelector('[aria-current="page"]');
  if (!active) return;

  // Passt alles nebeneinander (Desktop), gibt es nichts zu scrollen
  if (list.scrollWidth <= list.clientWidth + 1) return;

  const item = active.closest('li') || active;
  const listBox = list.getBoundingClientRect();
  const itemBox = item.getBoundingClientRect();

  // Aktiven Punkt mittig setzen; der Browser begrenzt selbst auf den Scrollbereich
  const versatz = itemBox.left - listBox.left - (listBox.width - itemBox.width) / 2;
  list.scrollLeft += versatz;
}

function initQuicklinkBars() {
  document.querySelectorAll('.custom-quicklinks-list').forEach(revealActiveQuicklink);
}

initQuicklinkBars();
document.addEventListener('shopify:section:load', initQuicklinkBars);


/* =====================================================
   Mobiles Menü – Tap auf Suche/Warenkorb kommt durch
   Vendor-Verhalten: snippets/main-menu-drawer.liquid (header-menu-drawer)

   Der Drawer erbt von DialogElement. Auf Touch-Geräten gibt
   allowOutsideClickForTarget() dort für alles außer den eigenen
   Hover-Triggern false zurück – der Focus-Trap verschluckt den Tap.
   Ergebnis: Das Menü schließt, die Suche öffnet sich aber nie.
   (Mit Maus greift ein anderer Zweig, deshalb nur mobil sichtbar.)

   Wir lassen den Tap durch, wenn er einem ANDEREN Dialog gilt
   (Suche, Warenkorb). Alles übrige bleibt beim Vendor-Verhalten:
   Tap daneben schließt weiterhin nur das Menü.
   ===================================================== */

function initMenuDrawerDurchgriff() {
  const drawer = document.getElementById('menu-drawer');
  if (!drawer || drawer.dataset.durchgriffReady === 'true') return;
  if (typeof drawer.allowOutsideClickForTarget !== 'function') return;
  drawer.dataset.durchgriffReady = 'true';

  const vendorVerhalten = drawer.allowOutsideClickForTarget.bind(drawer);

  drawer.allowOutsideClickForTarget = (target) => {
    if (vendorVerhalten(target)) return true;

    // Tap auf einen Auslöser, der einen anderen Dialog öffnet
    const ausloeser = target?.closest?.('[aria-controls]');
    if (!ausloeser) return false;

    return ausloeser.getAttribute('aria-controls') !== drawer.id;
  };
}

customElements.whenDefined('header-menu-drawer').then(initMenuDrawerDurchgriff);
document.addEventListener('shopify:section:load', initMenuDrawerDurchgriff);
